import { User } from "../models/User";
import { SIGN_IN } from "../resources/links";
import useUserAccount from "./userAccountHook";

function useAuth() {
    const { getAccount, getProfile } = useUserAccount();
    const user = new User(getProfile());
    const isSignInRoute = location.pathname === SIGN_IN;
    const redirectRoute = encodeURIComponent(location.pathname + location.search)

    const signInWithEmail = async () => {

        return;
    }

    const signInWithGoogle = async () => {

        return;
    }

    const signUserOut = async () => {

        return;
    }

    const isInsurerOnboarding = (): boolean => {
        return getAccount().isAuthenticated && user.isInsurer() && !getProfile().company?.setupCompleted;
    }

    const getPathToSignIn = () => {
        if (isSignInRoute) {
            return SIGN_IN;
        }
        return `${SIGN_IN}${redirectRoute ? `?redirect=${redirectRoute}` : ''}`;
    };

    return {
        signInWithEmail,
        signInWithGoogle,
        signUserOut,
        isInsurerOnboarding,
        getPathToSignIn
    }
}

export default useAuth;